declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '2146772642750880'
let initialized = false

export function initFBPixel() {
  if (initialized || typeof window === 'undefined') return

  // Define fbq function
  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Inject the FB pixel script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Init pixel
  window.fbq('init', PIXEL_ID)

  initialized = true
}

export function trackPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: '2026 Credit Architecture Bundle',
      content_type: 'product',
      value: 47.0,
      currency: 'USD',
    })
  }
}
